import { getPath } from '../../utils';
import * as React from 'react';
import { Partner, PartnerConfigName } from 'packages/smart-home-support/api/models';

export function getBaseSignupPath(pathname: string): string {
  return pathname
    .replace(/(?:\/\d\/?)?$/, '') // Remove page no. if present
    .replace(/^\//, '') // Remove trailing slash
    .replace(/\/$/, ''); // Remove leading slash
}

export function goBackFormPage(props): void {
  const basePath = getBaseSignupPath(props.location.pathname);
  const prevPage = props.step - 1;
  props.history.push(getPath(basePath, prevPage));
}

export function goToPage(props, page): void {
  const basePath = getBaseSignupPath(props.location.pathname);
  props.history.push(getPath(basePath, page));
}

export function getTotalPurchaseAmount(purchasePrice: number, taxAmount: number): string {
  return (purchasePrice + taxAmount).toFixed(2);
}

export function fieldProps(props, field, label) {
  const { onStateChange, validateInput, alerts, isLoading, onFieldMount, onFieldUnmount } = props;

  return {
    field,
    label,
    error: alerts[field],
    value: props[field],
    onStateChange,
    validateInput,
    onFieldMount,
    onFieldUnmount,
    disabled: isLoading,
  };
}

export interface PartnerConfig {
  partner: Partner;
  defaultPrice: number;
  webStoreCode?: string;
  alternatePricing?: AlternatePricingConfig[];
}

export interface AlternatePricingConfig {
  price: number;
  states: string[];
}

const verizonConfig: PartnerConfig = {
  partner: Partner.Verizon,
  defaultPrice: 20,
  webStoreCode: 'shsweb1',
};

const PartnerConfigMap: { [name: string]: PartnerConfig } = {
  [PartnerConfigName.Verizon]: verizonConfig,
  [PartnerConfigName.TechCoachHome]: verizonConfig,
  [PartnerConfigName.Sprint]: {
    partner: Partner.Sprint,
    defaultPrice: 25,
    webStoreCode: '0',
  },
  [PartnerConfigName.Asurion]: {
    partner: Partner.Asurion,
    defaultPrice: 25,
    webStoreCode: '0',
  },
};

export function getPartnerConfig(): PartnerConfig {
  return PartnerConfigMap[globals.REACT_APP_PARTNER];
}

export function partnerHasAlternatePricing(): boolean {
  const alternatePricing: AlternatePricingConfig[] | undefined = getPartnerConfig().alternatePricing;

  return alternatePricing !== undefined && alternatePricing.length > 0;
}

export function getProductPrice(state?: string): number {
  const partnerConfig: PartnerConfig = getPartnerConfig();

  let alternatePricing: AlternatePricingConfig | undefined;

  if (partnerConfig.alternatePricing && partnerConfig.alternatePricing.length > 0 && state !== undefined) {
    alternatePricing = partnerConfig.alternatePricing.find((pricing) => pricing.states.includes(state));
  }

  return alternatePricing ? alternatePricing.price : partnerConfig.defaultPrice;
}

export function getStateOptions(): JSX.Element[] {
  const states = [
    'AL',
    'AK',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DC',
    'DE',
    'FL',
    'GA',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY',
  ].map((v, i) => (
    <option key={i} value={v}>
      {v}
    </option>
  ));

  states.unshift(<option key="0000" value="" />);

  return states;
}



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/signup/utils.tsx